module.exports = __webpack_public_path__ + "static/media/golfer-4-b.4eea394c.png";